import axios from "axios";

const API_URL = "https://tomlonergan.dev/api";

export type Reading = {
  timestamp: Date;
  temperature: number | null;
  humidity: number | null;
  pressure: number | null;
};

export const getReadings = async (begin?: Date, end?: Date) => {
  let query = "";
  if (begin) {
    query = `?begin=${begin.getTime() * 1000000}`;
  }
  if (end) {
    query = query ? `${query}&end=${end.getTime() * 1000000}` : `?end=${end.getMilliseconds() * 1000000}`;
  }
  const response = await axios.get(`${API_URL}/readings${query}`);
  return response.data as Reading[];
};
